import React, { Component } from 'react';
import { connect } from 'react-redux';

import AnimatedPhone from './AnimatedPhone';
import { Singleton } from '../../js/Singleton';
import { hangUp } from '../../Images/CallSpaceHeaderSVG';
import { messageHangUp } from '../../redux/actions/A_messages_to_SM';
import { secondsToFormat } from '../../js/helpers/Utils/formats';
import { callAction } from '../../redux/actions/A_reducer_call_acd';
import { HANG_UP_SUBACTIONS, INTEGRATION } from '../../constants';
import { Logger } from '../../js/helpers/Logger.js';
import { SingletonSharedData } from '../../js/singletonSharedData'
import { hidePhone } from '../../js/helpers/Utils/formats';

class CallOutContainer extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    var _this = this;
    this.state = {
      time: _this.props.time
    };
    this.timeRefreshTime = 0.2;
    this.canvas = null;
    this.contextCanvas = null;
    this.timerRate = null;
    this.sharedData = new SingletonSharedData();
    this.isHidePhone = this.sharedData.getGeneralPermissions()[223];
    this.isPreview = this.sharedData.getDataPreviewPro().dialingMode === 1;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.HANG_UP_MANUAL_DIAL) {
      this.hangUp();
    }
  }
  componentDidMount() {
    this.canvas = this.refs["canvasTime"];
    this.contextCanvas = this.canvas.getContext("2d");
    this.drawArc(-Math.PI / 2.0, Math.PI * 1.5, false);
    this.setTimer();
  }
  componentWillUnmount() {
    clearInterval(this.timerRate);
  }
  drawArc(startAngle, endAngle) {
    this.contextCanvas.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.contextCanvas.strokeStyle = "#FFFFFF";
    let position = 36.0;
    this.contextCanvas.fillStyle = "transparent";
    this.contextCanvas.globalAlpha = 0.8;
    this.contextCanvas.lineWidth = 2;
    this.contextCanvas.beginPath();
    this.contextCanvas.arc(position, position, 35, startAngle, endAngle, false);
    this.contextCanvas.fill();
    this.contextCanvas.stroke();
  }

  setTimer() {
    var _this = this;
    this.timerRate = setInterval(time, (this.timeRefreshTime * 1000));
    function time() {
      let newTime = _this.state.time - _this.timeRefreshTime;
      if (newTime > 0) {
        _this.setState({ time: newTime });
      }

      let startAngle = -Math.PI / 2.0;
      let newAngle = startAngle + ((newTime / _this.props.time) * (Math.PI * 2.0));
      _this.drawArc(startAngle, newAngle, false);

      if (newTime <= 0) {
        clearInterval(_this.timerRate);
      }
    }
  }

  hangUp = () => {
    Logger.Debug("Hanging call ===>", HANG_UP_SUBACTIONS.MANUAL_CALL);
    this.props.userHangedout();
    this.props.messageHangUp(HANG_UP_SUBACTIONS.MANUAL_CALL,0,this.props.time?this.props.time:30);
  }

  render() {
    return (
      <div className={`CallOutContainer ${this.isPreview && 'previewCallOutContainer'}`}>
        <div className={` ${this.isPreview && 'previewContainer'}`}>
        <AnimatedPhone isPreview={this.isPreview}/>
        <canvas ref="canvasTime" className={`canvasCounterManualCall ${this.isPreview && 'preview'}`} width="72px" height="72px" >
        </canvas>
        <div className={`Data ${this.isPreview && 'previewData'}`}>
          <p className="DataClient">{hidePhone(this.isHidePhone, this.props.phone)}</p>
          <p className="Timer">{secondsToFormat(this.state.time, false)}</p>
          <p className="Calling">{this.language.getText("CallControlGUICallIOStatusmanualCall")}</p>
          <div className="buttonHangUpCallManualCall" onClick={this.hangUp}> {hangUp} </div>
        </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    messageHangUp: (subaction,callOutId,maxTime) => { dispatch(messageHangUp(subaction,callOutId,maxTime)); },
    callAction: (actionType, parameters) => { dispatch(callAction(actionType, parameters)); },
  });
}
export default CallOutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallOutContainer);



// WEBPACK FOOTER //
// ./src/components/Animations/CallOutContainer.jsx